import { useContext, useEffect, useRef } from 'react';
import { isInExoSkeleton, report, REPORT_TYPES } from '@adsk/exo-skeleton-api';
export const useProviderOnlyOnce = _ref => {
  let {
    context,
    contextName
  } = _ref;
  const OuterProvider = useContext(context);
  const shouldReportMultipleUsage = useRef(true);
  useEffect(() => {
    if (OuterProvider && shouldReportMultipleUsage.current) {
      if (isInExoSkeleton()) {
        report({
          type: REPORT_TYPES.info,
          value: "[Context Info] - ".concat(contextName, " is already in use more than once in react tree"),
          context: {
            contextName
          }
        });
      }
      console.warn("".concat(contextName, " is already in use, please use only one instance of ").concat(contextName, " (you may be wrapped with alloy provider)"));
      shouldReportMultipleUsage.current = false;
    }
  }, [OuterProvider, context.displayName, contextName]);
  return null;
};
//# sourceMappingURL=useProviderOnlyOnce.js.map